import { render, staticRenderFns } from "./DrawerApprovalChainDivision.vue?vue&type=template&id=33928554&scoped=true&"
import script from "./DrawerApprovalChainDivision.vue?vue&type=script&lang=js&"
export * from "./DrawerApprovalChainDivision.vue?vue&type=script&lang=js&"
import style0 from "./DrawerApprovalChainDivision.vue?vue&type=style&index=0&id=33928554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33928554",
  null
  
)

export default component.exports